export const optionPairs = {
  operativeProcedure: [
    ['not-specified', 'option-not-specified'],
    ['tur', 'option-transurethral-resection'],
    ['biopsy', 'option-biopsy'],
    ['other', 'option-other']
  ],
  specimenSite: [
    ['renal-pelvis', 'option-renal-pelvis'],
    ['ureter', 'option-ureter'],
    ['bladder', 'option-bladder-site'],
    ['prostate', 'option-prostate-site'],
    ['prostatic-urethra', 'option-prostatic-urethra'],
    ['urethra', 'option-urethra'],
    ['other', 'option-other']
  ],
  variantStatus: [
    ['', 'please-select'],
    ['not-identified', 'option-not-identified'],
    ['present', 'option-present']
  ],
  variantSubtype: [
    ['squamous', 'option-squamous'],
    ['glandular', 'option-glandular'],
    ['nested', 'option-nested'],
    ['micropapillary', 'option-micropapillary'],
    ['sarcomatoid', 'option-sarcomatoid'],
    ['plasmacytoid', 'option-plasmacytoid'],
    ['other', 'option-other']
  ],
  urothelialGrade: [
    ['', 'please-select'],
    ['punlmp', 'option-punlmp'],
    ['low-grade', 'option-low-grade'],
    ['high-grade', 'option-high-grade']
  ],
  growthPattern: [
    ['papillary', 'option-papillary'],
    ['exophytic', 'option-exophytic'],
    ['endophytic', 'option-endophytic'],
    ['infiltrating', 'option-infiltrating'],
    ['papillary-and-infiltrating', 'option-papillary-and-infiltrating']
  ],
  sccAdenocarcinomaGrade: [
    ['', 'please-select'],
    ['gx', 'option-gx'],
    ['g1', 'option-g1'],
    ['g2', 'option-g2'],
    ['g3', 'option-g3'],
    ['other', 'option-other']
  ],
  depthOfInvasion: [
    ['', 'please-select'],
    ['not-assessable-no-lamina-propria', 'option-depth-not-assessable'],
    ['ta-no-lamina-propria-invasion', 'option-depth-ta'],
    ['t1-focal-lamina-propria-invasion', 'option-depth-t1-focal'],
    ['t1-extensive-lamina-propria-invasion', 'option-depth-t1-extensive'],
    ['t2-muscularis-propria-invasion', 'option-depth-t2']
  ],
  concomitantFlatLesion: [
    ['', 'please-select'],
    ['none', 'option-none'],
    ['dysplasia', 'option-dysplasia'],
    ['flat-urothelial-carcinoma-in-situ', 'option-flat-urothelial-carcinoma-in-situ']
  ],
  muscularisPropria: [
    ['', 'please-select'],
    ['absent', 'option-absent'],
    ['present-not-involved', 'option-present-not-involved'],
    ['present-involved', 'option-present-involved']
  ],
  otherFinding: [
    ['inflammation-regenerative', 'option-inflammation-regenerative'],
    ['therapy-related', 'option-therapy-related'],
    ['cautery-artifact', 'option-cautery-artifact'],
    ['cystitis-cystica-et-glandularis', 'option-cystitis-cystica-et-glandularis'],
    ['keratinizing-squamous-metaplasia', 'option-keratinizing-squamous-metaplasia'],
    ['intestinal-metaplasia', 'option-intestinal-metaplasia'],
    ['other', 'option-other']
  ],
  weightStatus: [
    ['measured', 'option-weight-measured'],
    ['not-weighed', 'option-weight-not-weighed'],
    ['not-applicable', 'option-not-applicable']
  ],
  prostateGradeGroup: [
    ['', 'please-select'],
    ['grade-group-1', 'grade-group-1'],
    ['grade-group-2', 'grade-group-2'],
    ['grade-group-3', 'grade-group-3'],
    ['grade-group-4', 'grade-group-4'],
    ['grade-group-5', 'grade-group-5']
  ],
  gleasonScore: [
    ['', 'please-select'],
    ['3+3', 'option-gleason-3-3'],
    ['3+4', 'option-gleason-3-4'],
    ['4+3', 'option-gleason-4-3'],
    ['4+4', 'option-gleason-4-4'],
    ['3+5', 'option-gleason-3-5'],
    ['5+3', 'option-gleason-5-3'],
    ['4+5', 'option-gleason-4-5'],
    ['5+4', 'option-gleason-5-4'],
    ['5+5', 'option-gleason-5-5']
  ],
  presence: [
    ['', 'please-select'],
    ['present', 'present'],
    ['absent', 'absent']
  ],
  tertiaryPattern: [
    ['none', 'none'],
    ['pattern-3', 'pattern-3'],
    ['pattern-4', 'pattern-4'],
    ['pattern-5', 'pattern-5']
  ],
  prostateSpecimenResult: [
    ['', 'please-select'],
    ['benign-prostatic-tissue', 'option-benign-prostatic-tissue'],
    ['benign-stromal-tissue', 'option-benign-stromal-tissue'],
    ['no-prostate-tissue', 'option-no-prostate-tissue'],
    ['acinar-adenocarcinoma', 'option-acinar-adenocarcinoma'],
    ['other', 'option-other']
  ],
  prostateFindingStatus: [
    ['', 'please-select'],
    ['not-identified', 'option-not-identified'],
    ['present', 'option-present']
  ],
  prostateInvasionStatus: [
    ['', 'please-select'],
    ['not-identified', 'option-not-identified'],
    ['present', 'option-present']
  ]
};

export const prostateDefaultSpecimens = [
  { id: 'right-apex', code: 'A', labelKey: 'prostate-site-right-apex' },
  { id: 'right-mid', code: 'B', labelKey: 'prostate-site-right-mid' },
  { id: 'right-base', code: 'C', labelKey: 'prostate-site-right-base' },
  { id: 'left-apex', code: 'D', labelKey: 'prostate-site-left-apex' },
  { id: 'left-mid', code: 'E', labelKey: 'prostate-site-left-mid' },
  { id: 'left-base', code: 'F', labelKey: 'prostate-site-left-base' }
];

export const tumourTypeGroups = [
  {
    key: 'urothelial',
    labelKey: 'tumour-group-urothelial',
    children: [['urothelial-carcinoma', 'option-urothelial-carcinoma']]
  },
  {
    key: 'squamous',
    labelKey: 'tumour-group-squamous',
    children: [['squamous-cell-carcinoma', 'option-squamous-cell-carcinoma']]
  },
  {
    key: 'adenocarcinoma',
    labelKey: 'tumour-group-adenocarcinoma',
    children: [['adenocarcinoma', 'option-adenocarcinoma']]
  },
  {
    key: 'mullerian',
    labelKey: 'tumour-group-mullerian',
    children: [
      ['clear-cell-carcinoma', 'option-clear-cell-carcinoma'],
      ['endometrioid-carcinoma', 'option-endometrioid-carcinoma']
    ]
  },
  {
    key: 'neuroendocrine',
    labelKey: 'tumour-group-neuroendocrine',
    children: [
      ['small-cell-neuroendocrine-carcinoma', 'option-small-cell-neuroendocrine-carcinoma'],
      ['large-cell-neuroendocrine-carcinoma', 'option-large-cell-neuroendocrine-carcinoma']
    ]
  },
  {
    key: 'other',
    labelKey: 'tumour-group-other',
    children: [
      ['benign-condition', 'option-benign-condition'],
      ['other', 'option-other']
    ]
  }
];

export function translateOptions($t, pairs) {
  return pairs.map(([value, labelKey]) => ({
    value,
    label: $t(labelKey)
  }));
}

export function translateTumourTypeGroups($t) {
  return tumourTypeGroups.map(group => ({
    key: group.key,
    label: $t(group.labelKey),
    children: translateOptions($t, group.children)
  }));
}

export function flatTumourTypeOptions($t) {
  return translateTumourTypeGroups($t).reduce((options, group) => options.concat(group.children), []);
}
